/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.0.1
 * @since 1.0.0
 */
import produce from 'immer';

import { SuperSearchTypes } from './superSearchActions';
import {
    SUPER_SEARCH_CHANGE,
    SUPER_SEARCH_CLEAR,
    SUPER_SEARCH_EMPTY,
    SUPER_SEARCH_FAILED,
    SUPER_SEARCH_START,
    SUPER_SEARCH_SUCCESSFUL,
    SUPER_SEARCH_TOGGLE,
} from './superSearchConstants';
import { ISuperSearch } from './superSearchTypes';

/**
 * @description Super search reducer props
 * @interface ISuperSearchReducerState
 * @property {boolean} emptyList - empty search result
 * @property {boolean} isSearch - searching flag
 * @property {string} message - error message
 * @property {ISuperSearch} searchResponse - search result
 * @property {string} searchValue - search value
 */
export interface ISuperSearchReducerState {
    emptyList: boolean;
    isOpen: boolean;
    isSearch: boolean;
    message: string;
    searchReponse: ISuperSearch;
    searchValue: string;
}
export const initialSearchResponse: ISuperSearch  = {
    accounts: [],
    mobileLabels: [],
    mobiles: [],
}
export const initialSuperSearchState: ISuperSearchReducerState = {
    emptyList: false,
    isOpen: false,
    isSearch: false,
    message: '',
    searchReponse: initialSearchResponse,
    searchValue: '',
};

const superSearchReducer = (state: ISuperSearchReducerState = initialSuperSearchState, action: SuperSearchTypes) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SUPER_SEARCH_CHANGE:
                draft.message = '';
                draft.searchValue = action.payload;
                break;
            case SUPER_SEARCH_START:
                draft.emptyList = false;
                draft.isSearch = draft.searchValue.length > 1;
                draft.message = '';
                draft.searchReponse = initialSearchResponse;
                break;
            case SUPER_SEARCH_SUCCESSFUL:
                draft.emptyList = false;
                draft.isSearch = false;
                draft.message = '';
                draft.searchReponse = action.payload;
                break;
            case SUPER_SEARCH_EMPTY:
                draft.emptyList = true;
                draft.isSearch = false;
                draft.message = '';
                draft.searchReponse = initialSearchResponse;
                break;
            case SUPER_SEARCH_FAILED:
                draft.emptyList = false;
                draft.isSearch = false;
                draft.message = action.payload;
                break;
            case SUPER_SEARCH_CLEAR:
                draft.emptyList = false;
                draft.isSearch = false;
                draft.message = '';
                draft.searchReponse = initialSearchResponse;
                draft.searchValue = '';
                break;
            case SUPER_SEARCH_TOGGLE:
                draft.isOpen = action.payload;
                break;
            default:
                break;
        }
    });

export default superSearchReducer;
